export default __webpack_public_path__ + "static/experiments-ba2b8830a40b76472d0e8a71855447d9.png";